import { useSelector, useDispatch } from 'react-redux';

import app from 'app/config/app';
import FilterValues from 'core/filter/FilterValues';
import { deleteFilterParams } from 'app/features/partner-funding-sources/partnerFundingSourceSlice';

export default function PartnerFundingSourceFilterValues() {
  const dispatch = useDispatch();

  const { params } = useSelector((state) => state.partnerFundingSources.index);

  const handleOnRemoveFilter = (key) => {
    dispatch(deleteFilterParams(key));
  };

  return (
    <FilterValues
      value={params}
      onRemoveFilter={handleOnRemoveFilter}
      ignoreKeys={app.ignoreFilterKeys}
    />
  );
}